import { css } from 'lit';

export const style = css`
  * {
    margin: 0;
    padding: 0;
  }

  ul {
    display: flex;
    flex-direction: row;
    font-weight: 300;
    list-style: none;
    text-transform: uppercase;
  }

  ul li {
    flex: 1;
  }

  ul,
  li > p {
    margin: 0;
    padding: 0;
  }

  ul li > p:first-child {
    font-size: 1.5em;
  }

  ul li > p:last-child {
    font-size: 0.75em;
    letter-spacing: 1px;
  }

  ul sup {
    font-size: 0.5em;
  }

  ul span {
    color: #008140;
  }

  ul span.negative {
    color: #cc2427;
  }

  .offer {
    display: flex;
    justify-content: center;
    margin-bottom: 1em;
    text-align: center;
  }

  .offer > div {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 50%;
  }

  .offer > div:first-of-type {
    border-right: 1px solid #687680;
  }

  .offer-label {
    font-size: 0.625em;
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }

  .monthly-payment p:first-child {
    font-size: 3em;
    line-height: 1.25;
  }

  .offer p:first-child sup {
    font-size: 0.5em;
    vertical-align: super;
  }

  .apr {
    margin-bottom: 0.5em;
  }

  .grv-text__heading--large {
    font-size: 32px;
    font-weight: 300;
    line-height: 1.3;
    margin-bottom: 0;
  }

  .apr p:first-child,
  .term p:first-child {
    font-size: 1.5em;
    line-height: 1.5;
  }

  /** Compare Old Loan Styling **/
  .compare-old-loan-details {
    text-transform: none;
  }

  .compare-old-loan-details p:first-child {
    font-size: 12px;
  }

  .compare-old-loan-details p:last-child {
    font-size: 32px;
  }

  .compare-old-loan-details .apr p:last-child,
  .compare-old-loan-details .term p:last-child {
    font-size: 16px;
  }

  .compare-old-loan-details .monthly-details {
    margin-left: 6px;
    width: 147px;
  }

  .apr-column {
    min-width: 72px;
  }

  .compare-old-loan-details .apr {
    width: 70px;
  }

  .compare-old-loan-details .other-details {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    padding: 0;
  }

  .exit-modal {
    background-color: #0276b1;
  }

  .card-column {
    width: fit-content;
  }

  .grv-grid .grv-row {
    padding-left: unset;
    padding-right: unset;
  }

  .card-details-gap {
    column-gap: 24px;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .card-details-dynamic {
      justify-content: space-between;
    }
  }

  @media only screen and (min-width: 768px) {
    .card-details-dynamic {
      column-gap: 94px;
    }
  }

  .calendar-text-box {
    align-items: center;
    display: flex;
  }

  fs-icon {
    left: 6px;
    position: relative;
  }

  .calendar-small::part(fs-icon) {
    height: 16px;
    width: 16px;
  }

  @media only screen and (min-width: 375px) {
    .justify-between {
      justify-content: space-between;
    }
  }
`;
